/* jshint esnext: true */
import { $document, APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Accordion';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.scrollto = true;

        if(typeof options.noscrollto === 'string'){
            this.scrollto = false;
        }
        this.$el.on(EVENT.CLICK, '.js-accordion-header', (event) => this.toggle(event));

    }

    toggle(event) {
        event.preventDefault();

        var $this = $(event.currentTarget);

        let delay = 0;

        if ($this.parent().hasClass('is-open')) {
            $this.parent().removeClass('is-open');
            setTimeout(()=>{
                $this.siblings('.js-accordion-content')
                     .stop()
                     .slideUp();
            },300);
        } else {
            if($('.js-accordion-item.is-open').length > 0){
                delay = 800;
            }
            $('.js-accordion-item.is-open', this.$el).removeClass('is-open');

            $('.js-accordion-content').stop().slideUp();

            $this.siblings('.js-accordion-content')
                 .stop()
                 .slideDown();

            $this.parent().addClass('is-open');

            if(this.scrollToTimeout != undefined){
                clearTimeout(this.scrollToTimeout);
            }
            if(this.scrollto){
                this.scrollToTimeout = setTimeout(()=>{
                    let $currentItem = this.$el.find('.js-accordion-item.is-open').first();

                    if ($currentItem.length) {
                        $('#js-scroll').trigger({
                            type: 'scrollTo.LocomotiveScroll',
                            options: {
                                targetElem: $currentItem,
                                targetOffset: -100
                            }
                        });
                    }
                },delay);
            }
        }
    }

    destroy() {
        this.$el.off(EVENT_NAMESPACE);

        if(this.scrollToTimeout != undefined){
            clearTimeout(this.scrollToTimeout);
        }
    }
}
